export const parseYesNoBoolean = (value: unknown): boolean | undefined => {
	if (typeof value === 'boolean') return value;
	if (typeof value === 'string') {
		if (value.toLowerCase() === 'yes') return true;
		if (value.toLowerCase() === 'no') return false;
	}
	return undefined;
};
